import { FC } from "react";
import { useTranslation } from "react-i18next";
import ServiceDuration from "../../../service-duration/service-duration";
import ServiceProfessionalsCard from "../../../service-professionals-card/service-professionals-card";
import { ProductInformationWrapper } from "../product-information/product-information.styled";

const ServiceConfig: FC = () => {
  const { t } = useTranslation();

  return (
    <ProductInformationWrapper>
      <div className="title">
        <div className="text">
          {t("productComponent.service.config.title")}
        </div>
      </div>
      <div className="content">
        <ServiceDuration />
        <ServiceProfessionalsCard />
      </div>
    </ProductInformationWrapper>
  );
};

export default ServiceConfig;
